import { reasonCodeLabel } from '@/lib/orderActionReasons';
import type { OrderActionRef } from '@/types/clinicalAdmin';

const ACTION_LABELS: Record<string, string> = {
  reship: 'Reship',
  refire: 'Refire',
  rescript: 'Rescript',
  cancel: 'Cancel',
  cancel_and_refund: 'Cancel and refund',
  cancel_subscription: 'Cancel subscription',
  refund: 'Refund',
  intake_override: 'Intake override',
};

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

/** "Lost in transit (lost_in_transit)" — the label for reading, the raw
 * code for searching and reporting. */
export function reasonCodeDisplay(code: string): string {
  const label = reasonCodeLabel(code);
  return label === code ? code : `${label} (${code})`;
}

/** "SYS-055CD73B (e5bc099e-…)" — number first, full id for lookups. */
export function orderRefDisplay(ref: OrderActionRef | null): string {
  if (!ref) return '—';
  return ref.order_number ? `${ref.order_number} (${ref.id})` : ref.id;
}

/** Audit timestamps render in UTC, to the second, so they line up with
 * backend logs and pharmacy portals regardless of the viewer's timezone. */
export function fmtAuditTimestamp(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  const date = d.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const time = d.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
  return `${date} at ${time} UTC`;
}
